import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { FileUploader } from 'ng2-file-upload';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/Rx';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-importa-anagrafica',
  templateUrl: './importa-anagrafica.component.html',
  styleUrls: ['./importa-anagrafica.component.css']
})
export class ImportaAnagraficaComponent extends AppComponentGenericComponent implements OnInit {
	headers: HttpHeaders;
	uploader: FileUploader;
	uploadUrl: string = '/api/importa/anagrafica';
	converterUrl: string;
	fileName: string;
	accept: string;
	acceptList: any[] = [
		{
			name: 'CSV',
			value: '.csv'
		},
		{
			name: 'EXCEL',
			value: '.xls , .xlsx'
		},
	];
	importResponse: any = null;
	aggiornaAnagrafica: boolean = false;
	generazioneCompletata: boolean = false;
	comuneId: string;
	comuneSync: Subscription;

	constructor(protected dataService: DataService) {
		super(dataService, 'import-anagrafica');
		let serverUrl = this.dataService.getCommon().getDB().serverUrl;
		this.converterUrl = serverUrl+'/proxy/import/anagrafica/import_anagrafica';
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');
		this.headers.append('Accept', 'application/json');
		this.uploader = new FileUploader({url: this.uploadUrl });
		this.uploader.onCompleteAll = () => {
			console.log("onCompleteAll ok");
			this.fileConversion();
		};
	}

	ngOnInit() {
		this.accept = this.acceptList[0].value;
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			(comune) => {
				this.comuneId = comune.id;
		});
	}

	fileConversion() {
		this.dataService.openLoader('IMPORTAZIONE ANAGRAFICA','conversione e inizializzazione degli anagrafica in corso...');
		let acceptExtension = "";
		for(let acceptElement of this.acceptList){
			switch(acceptElement['name']){
				case 'CSV':
					if(acceptElement['value'] == this.accept)
						acceptExtension = "_csv";
					break;
				case 'EXCEL':
					if(acceptElement['value'] == this.accept)
						acceptExtension = "_excel";
					break;
				default:
			}
		}
		this.converterUrl += acceptExtension + ".php";
		let body: any = {
			fileName: this.fileName,
			comuneId: this.comuneId,
			aggiornamentoUtente: this.dataService.getUtentiService().getUser().id,
			aggiornamentoData: String(Math.floor(Date.now()/1000)),
			aggiornaAnagrafica: this.aggiornaAnagrafica
		};

		console.log('FILE CONVERTION', body);

		this.dataService.getCommon().getHttpClient().post<any>(this.converterUrl, JSON.stringify(body), { headers: this.headers })
			.subscribe(
				response => {
					console.log('IMPORT RESPONSE', response);
					this.importResponse = response;
					this.generazioneCompletata = true;
					this.dataService.closeLoader();
					this.dataService.refreshData("anagrafica");
				}
			);
	}

	removeFiles(){
		this.uploader.clearQueue();
	}

	nameFormatter(name: string) {
		this.fileName = this.comuneId + '_' + name.split(' ').join('_').toLowerCase();
	}

	uploadFile(item: any){
		this.importResponse = null;

		this.nameFormatter(item.file.name);
		item.file.name = this.fileName;
		item.upload();
	}

	apriAnagrafica(){
		this.dataService.navigateByUrl('/anagrafica');
	}

	ngDestroy(){
		this.comuneSync.unsubscribe();
	}
}
